// extracted by mini-css-extract-plugin
export var checkbox = "_4q-0";
export var circle = "_4q-3";
export var horizontalContainer = "_4q-7";
export var sm = "_4q-5";
export var switch0 = "_4q-2";
export var switchDisabled = "_4q-8";
export var switchEnabled = "_4q-1";
export var textSwitchContainer = "_4q-9";
export var textSwitchOption = "_4q-a";
export var textSwitchOptionSelected = "_4q-b";
export var verticalContainer = "_4q-6";
export var xs = "_4q-4";